/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionContext, Module } from 'vuex';
import store from '@/store';
import generateMutations, {
  UPDATE_STATE_TYPE,
} from '@/store/generate-mutations';
import type RootStateType from '@/store/types';
import { ContractData } from '@/api/contract/types';
import { ProductContracts } from '@/ContractConfig';
import ContractApi from '@/api/contract';
import { ContractEnum } from '@/enums/contract-type';
import { getLoanUsage } from '@/api/dict';
import type { OptionItem } from '@/model/OptionItem';
import { isNewYhChannel, ZHONGYOU_COMMODITY } from '@/shared/commodity';
import type { StateType } from './types';
import { sortAgreements } from './utils';

const moduleStore: Module<StateType, RootStateType> = {
  namespaced: true,
  state: {
    applyChooseList: null,
    // 贷超半流程授信有授信渠道返回为true
    isDcHalfApply: false,
    agreements: [],
    creditRouteChannel: undefined,
    submitCommodityIds: [],
    commodityModelList: [],
  },
  actions: {
    // 获取线上协议数据
    async getOnlineContract(
      context: ActionContext<StateType, RootStateType>,
      commodityId: number,
    ): Promise<ContractData[]> {
      const loanUsageArr: OptionItem[] = (await getLoanUsage()) || [];
      const data = await ContractApi.getDynamicUrl({
        commodityId,
        type: String(commodityId) === ZHONGYOU_COMMODITY ? ContractEnum.ZY_PREAPPLY : ContractEnum.PREAPPLY,
        loanUsage: String(
          loanUsageArr[
            parseInt(String(Math.random() * loanUsageArr.length), 10)
          ].code,
        ),
      });
      return data;
    },
    // 获取渠道协议信息
    async getAgreements(
      context: ActionContext<StateType, RootStateType>,
      commodityId: number,
    ): Promise<void> {
      try {
        const { preApplyContracts } = ProductContracts[commodityId] || Object.create(null);

        if (!preApplyContracts) {
          await context
            .dispatch('getOnlineContract', commodityId)
            .then((data: ContractData[]) => {
              context.dispatch(UPDATE_STATE_TYPE, {
                agreements: sortAgreements(data),
              });
            });
        } else if (+this.commodityId === 3900) {
          await context.dispatch(UPDATE_STATE_TYPE, {
            agreements: sortAgreements([
              ...(preApplyContracts.items || []),
              // 微博-协议（线上和线下都有）临时处理方式
              ...(await context.dispatch('getOnlineContract', commodityId)),
            ]),
          });
        } else {
          let contractForm: any;

          if (isNewYhChannel(String(commodityId))) {
            contractForm = await ContractApi.newYhConstract({
              commodityId,
              loanOrderId: '',
              repayStatus: '',
            });
          }
          const { funderCode } = contractForm || {};
          const result = (funderCode === 'HENGSHENG' ? preApplyContracts.spareItems : preApplyContracts.items) || [];
          context.dispatch(UPDATE_STATE_TYPE, {
            agreements: sortAgreements(
                Array.from(result) as ContractData[],
            ),
          });
        }
        return Promise.resolve();
      } catch (error) {
        context.dispatch(UPDATE_STATE_TYPE, {
          agreements: Array.from([]),
        });
        return Promise.reject();
      }
    },
  },
};

store.registerModule(
  'preApplyChoose',
  generateMutations<StateType>(moduleStore),
);
